module.exports = __webpack_public_path__ + "static/media/tr.393621f9.svg";